import {branchPath} from '@github-ui/paths'
import {BranchName} from '@primer/react'
import {Tooltip} from '@primer/react/experimental'
import styles from './PullRequestBranchName.module.css'

export function PullRequestBranchName({
  branchText,
  repositoryOwner,
  repositoryName,
  branch,
  button,
}: {
  branchText: string
  repositoryName: string
  repositoryOwner: string
  branch: string
  button?: React.ReactNode
}) {
  const name =
    repositoryName && repositoryOwner ? (
      <Tooltip text={`${repositoryOwner}/${repositoryName}:${branch}`}>
        <BranchName
          href={branchPath({owner: repositoryOwner, repo: repositoryName, branch})}
          className={styles.branchName}
        >
          {branchText}
        </BranchName>
      </Tooltip>
    ) : (
      <BranchName as="span" className={styles.branchName} title="This repository has been deleted">
        {branchText}
      </BranchName>
    )

  if (!button) return name

  return (
    <div className={styles.branchWithButton}>
      {name}
      {button}
    </div>
  )
}
